// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import CheckShield20 from './CheckShield20.tsx';
import CheckShield20Filled from './CheckShield20Filled.tsx';
import CheckShield20CircleFilled from './CheckShield20CircleFilled.tsx';
import CheckShield24 from './CheckShield24.tsx';
import CheckShield24Filled from './CheckShield24Filled.tsx';
import CheckShield24CircleFilled from './CheckShield24CircleFilled.tsx';
import CheckShield40 from './CheckShield40.tsx';
import CheckShield40Filled from './CheckShield40Filled.tsx';
import CheckShield48 from './CheckShield48.tsx';
import CheckShield48Filled from './CheckShield48Filled.tsx';

type CheckShieldProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    CheckShield20,
    CheckShield20Filled,
    CheckShield20CircleFilled,
    CheckShield24,
    CheckShield24Filled,
    CheckShield24CircleFilled,
    CheckShield40,
    CheckShield40Filled,
    CheckShield48,
    CheckShield48Filled,
};

const CheckShield: FC<CheckShieldProps> = ({ variation, ...props }) => {
    const variationKey = `CheckShield${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"CheckShield" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default CheckShield;
